<template>
  <v-form
    @submit="onSubmit"
    ref="form"
    :action="this.server + this.$route.fullPath"
    id="form-contact"
    v-model="valid"
    lazy-validation
  >
    <label
      class="white--text text-h6 font-weight-light"
      :class="{ 'white--text': !mobile, 'primary--text': mobile }"
      for="name"
    >
      Nome:
    </label>
    <v-text-field
      id="name"
      required
      class="mt-3 rounded-0 elevation-0"
      :height="!xsOnly ? `48px` : `42px`"
      dense
      name="name"
      :rules="nameRules"
      :outlined="mobile"
      :solo="!mobile"
    ></v-text-field>

    <label
      class="white--text text-h6 font-weight-light"
      :class="{ 'white--text': !mobile, 'primary--text': mobile }"
      for="tel"
    >
      Telefone:
    </label>
    <v-text-field
      id="tel"
      required
      class="mt-3 rounded-0 elevation-0"
      :height="!xsOnly ? `48px` : `42px`"
      dense
      name="tel"
      :rules="telRules"
      v-mask="'(##) # ####-####'"
      :outlined="mobile"
      :solo="!mobile"
    ></v-text-field>

    <label
      class="white--text text-h6 font-weight-light"
      :class="{ 'white--text': !mobile, 'primary--text': mobile }"
      for="email"
    >
      E-mail:
    </label>
    <v-text-field
      id="email"
      required
      class="mt-3 rounded-0 elevation-0"
      :height="!xsOnly ? `48px` : `42px`"
      dense
      name="email"
      :rules="emailRules"
      :outlined="mobile"
      :solo="!mobile"
    ></v-text-field>

    <label
      class="white--text text-h6 font-weight-light"
      :class="{ 'white--text': !mobile, 'primary--text': mobile }"
      for="message"
    >
      Mensagem:
    </label>
    <v-textarea
      class="mt-3 rounded-0 elevation-0"
      id="message"
      dense
      name="text"
      :rules="messageRules"
      required
      no-resize
      height="122px"
      :outlined="mobile"
      :solo="!mobile"
    ></v-textarea>

    <v-checkbox
      name="policy_privacy"
      v-model="policy_privacy"
      :rules="[(v) => !!v || 'Você precisa aceitar para continuar.']"
      value="1"
      class="policy-privacy"
      :color="mobile ? 'primary' : 'white'"
    >
      <template v-slot:label>
        <div
          class="text-form text-caption"
          :class="{ 'white--text': !mobile, 'primary--text': mobile }"
        >
          Eu li e concordo com a
          <a
            class="font-weight-bold"
            :class="{ 'white--text': !mobile, 'primary--text': mobile }"
            @click="showPrivacy"
          >
            política de privacidade.
          </a>
        </div>
      </template>
    </v-checkbox>

    <div class="d-flex justify-center">
      <v-btn
        :loading="loadingForm"
        class="
          secondary--text
          gradiente-bg
          text-none text-body-2
          font-weight-bold
          rounded-0
          px-12
        "
        type="submit"
        depressed
        :height="!xsOnly ? `48px` : `42px`"
        width="auto"
      >
        Enviar
      </v-btn>
    </div>

    <v-snackbar :color="color" centered v-model="snackbar" :multi-line="true">
      {{ response }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false" icon>
          <v-icon> fa fa-times </v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-form>
</template>
<script>
import { mask } from "vue-the-mask";
export default {
  directives: { mask },

  data: () => ({
    response: "",
    color: "success",
    loadingForm: false,
    snackbar: false,
    valid: true,
    nameRules: [(v) => !!v || "Digite seu nome."],
    telRules: [(v) => !!v || "Digite seu telefone."],
    emailRules: [
      (v) => !!v || "Digite seu e-mail.",
      (v) => /.+@.+\..+/.test(v) || "Digite um e-mail válido.",
    ],
    brandRules: [(v) => !!v || "Digite o nome da sua sua marca."],
    areaRules: [(v) => !!v || "Digite a área da sua sua marca."],
    messageRules: [(v) => !!v || "Digite sua mensagem."],
    policy_privacy: false,
  }),
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    showPrivacy: () => window.showPrivacyPolicy(),
    onSubmit(event) {
      const form = document.getElementById("form-contact");
      if (this.$refs.form.validate()) {
        this.loadingForm = true;
        const formData = new FormData(form);
        const action = `${this.server}/rest/email/contact-us`;
        fetch(action, {
          method: "POST",
          body: formData,
        })
          .then((r) => {
            if (r.ok) {
              if (window.dataLayer) {
                window.dataLayer.push({ event: "form_submit_contact-us" });
              }
              this.$router.push("/obrigado");
            } else {
              this.response =
                "OPS! tivemos um problema no envio das informações, tente novamente mais tarde.";
              this.color = "red accent-2";
              this.snackbar = true;
              this.loadingForm = false;
            }
          })
          .catch(() => {
            this.response =
              "OPS! tivemos um problema no envio das informações, tente novamente mais tarde.";
            this.color = "red accent-2";
            this.snackbar = true;
            this.loadingForm = false;
          });
      }
      event.preventDefault();
    },
  },
};
</script>

<style>
.v-input--selection-controls__input i {
  color: #fff !important;
}
@media (max-width: 1264px) {
  .v-input--selection-controls__input i {
    color: var(--v-primary-base) !important;
  }
}
.v-input__slot {
  margin: 0 !important;
}
.v-input--selection-controls {
  margin-top: 12px !important;
}
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin: 0 !important;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.03),
    0px 4.91399px 13.4018px rgba(0, 0, 0, 0.0298054),
    0px 1.46302px 3.99006px rgba(0, 0, 0, 0.0201946) !important;
}
.v-text-field.v-text-field--enclosed .v-text-field__details {
  padding: 2px 0 0 0 !important;
}
.theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
  background-color: rgba(255, 255, 255, 0.9) !important;
}
</style>
